import { appApi } from '@web/app/store/api'
import type { AuthType, LoginType } from '@web/types'
import { IUser } from '../../usuarios/types'

type ForgotPasswordRequest = { username: string }
type ForgotPasswordResponse = { masked_email: string; message: string }

type ResetPasswordConfirmRequest = { username: string; code: string; new_password: string }
type ResetPasswordConfirmResponse = { message: string }

export const authApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    token: builder.mutation<AuthType, LoginType>({
      query: (body) => ({
        url: `/api/v1/auth/login`,
        method: 'POST',
        body,
      }),
      extraOptions: {
        unauthenticated: true,
      },
    }),
    getUserProfile: builder.query<{ data: IUser }, void>({
      query: () => ({
        url: '/api/v1/users/profile',
        method: 'GET',
      }),
    }),
    forgotPassword: builder.mutation<ForgotPasswordResponse, ForgotPasswordRequest>({
      query: (body) => ({
        url: '/api/v1/auth/forgot-password',
        method: 'POST',
        body,
      }),
      extraOptions: {
        unauthenticated: true,
      },
    }),
    resetPasswordConfirm: builder.mutation<ResetPasswordConfirmResponse, ResetPasswordConfirmRequest>({
      query: (body) => ({
        url: '/api/v1/auth/reset-password-confirm',
        method: 'POST',
        body,
      }),
      extraOptions: {
        unauthenticated: true,
      },
    }),
  }),
  overrideExisting: 'throw',
})
